<script setup lang="ts">
const accessStore = useAccessStore();
const { t } = useI18n();
</script>

<template>
  <div
    v-if="accessStore.isPartialAccessDenied"
    class="access-denied-overlay d-flex align-items-center justify-content-center"
  >
    <div class="text-center p-5 bg-white rounded shadow">
      <i class="fas fa-lock fa-3x text-danger mb-3" />
      <h3 class="mb-2">{{ t('access_denied.title') }}</h3>
      <p class="text-muted mb-2">{{ accessStore.deniedMessage }}</p>
      <p class="text-muted mb-4">
        {{ t('access_denied.support.description') }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.access-denied-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  z-index: 5;
}
</style>
